import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	isUncancelable: ForNodeType<boolean>;
	onSetIsUncancelable: (input: boolean) => void;
};

export const QuestionPlanIsUncancelable = ({ isUncancelable, onSetIsUncancelable }: Props) => {
	const label = "キャンセル不可プラン";
	const guide =
		"                            キャンセルができないプランを作成することができます。<br />宿泊の55日前以降に行われる決済でエラーが出た場合は自動的にキャンセルされます。また、ホストによるキャンセルは可能です。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isUncancelable.isEdited}
			hasError={Boolean(isUncancelable.error)}
			inputChildren={
				<CheckboxField
					value={isUncancelable.value}
					label={"キャンセル不可プランにする"}
					handleChange={onSetIsUncancelable}
					errorMessage={isUncancelable.error}
				/>
			}
		/>
	);
};

QuestionPlanIsUncancelable.displayName = "QuestionPlanIsUncancelable";
